webpackJsonp([189203873617288],{

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(9);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var names = ['Radcliffe Takashi Onishi', 'Yokoishi Keisuke', 'Taniguchi Kazuki'];
	var roles = ['CEO  Founder / Producer', 'COO / Product Management', 'CDO / Data Scientist', 'Backend, Blockchain Engineer', 'Frontend Engineer', 'Political Scientist / Contents Management', 'Content Editor'];
	var snses = [{
	  twitter: 'takac_radcliffe',
	  facebook: 'takac.radcliffe'
	}, {}, {}, {}, {
	  github: 'e-jigsaw'
	}, {}, {}];
	
	var Person = function Person(_ref) {
	  var name = _ref.name,
	      index = _ref.index,
	      t = _ref.t;
	
	  var sns = snses[index];
	  var links = Object.keys(sns);
	  return _react2.default.createElement(
	    'div',
	    { className: 'person' },
	    _react2.default.createElement(
	      'div',
	      { className: 'person-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'person-profile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'person-name-title' },
	          _react2.default.createElement(
	            'div',
	            { className: 'person-name' },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'person-title' },
	            roles[index]
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'person-message-container person-message-container__pc' },
	          _react2.default.createElement(
	            'div',
	            { className: 'person-message' },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('m' + index)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'person-links' },
	              links.map(function (key, index) {
	                var link = void 0;
	                switch (key) {
	                  case 'twitter':
	                    {
	                      link = _react2.default.createElement(
	                        'a',
	                        { href: 'https://twitter.com/' + sns.twitter },
	                        'tw'
	                      );
	                      break;
	                    }
	                  case 'facebook':
	                    {
	                      link = _react2.default.createElement(
	                        'a',
	                        { href: 'https://fb.me/' + sns.facebook },
	                        'fb'
	                      );
	                      break;
	                    }
	                  case 'blog':
	                    {
	                      link = _react2.default.createElement(
	                        'a',
	                        { href: sns.blog },
	                        'blog'
	                      );
	                      break;
	                    }
	                  case 'github':
	                    {
	                      link = _react2.default.createElement(
	                        'a',
	                        { href: 'https://github.com/' + sns.github },
	                        'github'
	                      );
	                      break;
	                    }
	                }
	                return links[index + 1] ? _react2.default.createElement(
	                  'span',
	                  null,
	                  link,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'person-middot' },
	                    '\xB7'
	                  )
	                ) : link;
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'person-message-container person-message-container__sp' },
	      _react2.default.createElement(
	        'div',
	        { className: 'person-message' },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('m' + index)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'person-links' },
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'tw'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'person-middot' },
	            '\xB7'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'fb'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'person-middot' },
	            '\xB7'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'blog'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'person-middot' },
	            '\xB7'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'github'
	          )
	        )
	      )
	    )
	  );
	};
	
	var Member = (0, _reactI18next.translate)('member')(function (_ref2) {
	  var t = _ref2.t;
	  return _react2.default.createElement(
	    'div',
	    { id: 'member' },
	    _react2.default.createElement(_Header2.default, { current: 'member' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col1 col-pad1' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          'Member'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col3 member-list' },
	        names.map(function (name, index) {
	          return _react2.default.createElement(Person, { key: index, name: name, index: index, t: t });
	        })
	      )
	    )
	  );
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{ name: 'description', content: 'Babels Members' }, { property: 'og:title', content: 'Babels Members' }, { property: 'og:url', content: 'https://babels.co/member' }, { property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff' }, { property: 'og:image:width', content: '600' }, { property: 'og:image:height', content: '400' }, { property: 'og:description', content: 'Babels Members' }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@null' }, { name: 'twitter:creator', content: '@null' }]
	    }),
	    _react2.default.createElement(Member, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-member-js-08b40944eba30073ec5c.js